module.exports = __webpack_public_path__ + "media/country_flags/tf-02ffd195.png";